/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useState } from "react";
import { Avatar, Chip, Stack, Tooltip, Typography } from "@mui/material";
import {
  Apartment,
  Badge,
  Business,
  Engineering,
  Female,
  Group,
  Male,
  PermIdentity,
  Work,
} from "@mui/icons-material";
import { PersonnelModel } from "RosterData";
import PersonnelScreen from "../PersonnelScreen/PersonnelScreen";
import { baseURL } from "../../api";
import PersonnelAvatar from "../PersonnelScreen/PersonnelAvatar";

interface PersonnelCellProps {
  personnelData: PersonnelModel;
  showPersonnelId: boolean;
}

const PersonnelCell = (props: PersonnelCellProps) => {
  const [openPersonnelInfo, setOpenPersonnelInfo] = useState(null);

  const handlePersonnelClick = (e: any) => {
    setOpenPersonnelInfo(e.currentTarget);
  };

  return (
    <>
      {openPersonnelInfo && props.personnelData.personnelId > 0 && (
        <PersonnelScreen
          anchorEl={openPersonnelInfo}
          onClose={setOpenPersonnelInfo}
          personnelId={props.personnelData.personnelId}
        />
      )}
      <Stack
        spacing={1}
        direction="row"
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        onClick={handlePersonnelClick}
        sx={{ width: "100%", cursor: "pointer" }}
      >
        <PersonnelAvatar personnelData={props.personnelData} />
        <Typography
          variant="subtitle2"
          sx={{
            maxWidth: 145,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {`${props.personnelData.forenames[0]}.${props.personnelData.surname}`}
        </Typography>
        {props.showPersonnelId && props.personnelData.personnelId > 0 && (
          <Tooltip title="Vantage Id" placement="top" arrow>
            <Chip
              icon={<PermIdentity fontSize="small" />}
              label={props.personnelData.personnelId}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.sex && (
          <Tooltip title="Sex" placement="top" arrow>
            <Chip
              icon={props.personnelData.sex === "M" ? <Male /> : <Female />}
              label={props.personnelData.sex}
              size="small"
              sx={{
                maxWidth: 45,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.employer && (
          <Tooltip title="Employer" placement="top" arrow>
            <Chip
              icon={<Apartment />}
              label={props.personnelData.employer}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.discipline && (
          <Tooltip title="Discipline" placement="top" arrow>
            <Chip
              icon={<Work />}
              label={props.personnelData.discipline}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.jobTitle && (
          <Tooltip title="Job Title" placement="top" arrow>
            <Chip
              icon={<Badge />}
              label={props.personnelData.jobTitle}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.coreCrew &&
          props.personnelData.coreCrew === "Y" && (
            <Tooltip title="Core Crew" placement="top" arrow>
              <Chip
                icon={<Engineering />}
                label="CORE"
                size="small"
                sx={{
                  maxWidth: 73,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              />
            </Tooltip>
          )}
        {props.personnelData.team && (
          <Tooltip title="Team" placement="top" arrow>
            <Chip
              icon={<Group />}
              label={props.personnelData.team}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
        {props.personnelData.deptCode && (
          <Tooltip title="Department" placement="top" arrow>
            <Chip
              icon={<Business />}
              label={props.personnelData.deptCode}
              size="small"
              sx={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </Tooltip>
        )}
      </Stack>
    </>
  );
};
export default PersonnelCell;
